module.exports = __webpack_public_path__ + "img/smart-grid-hero.7cf61633.webp";